export default "__VITE_ASSET__vuWz3KaT__"